import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class IndexmanagerService {

  constructor(private http: HttpClient) { }

  checkMonth: Array<Object> = [
    {
      number: 1,
      name: 'มกราคม'
    },
    {
      number: 2,
      name: 'กุมภาพันธ์'
    },
    {
      number: 3,
      name: 'มีนาคม'
    },
    {
      number: 4,
      name: 'เมษายน'
    },
    {
      number: 5,
      name: 'พฤษภาคม'
    },
    {
      number: 6,
      name: 'มิถุนายน'
    },
    {
      number: 7,
      name: 'กรกฎาคม'
    },
    {
      number: 8,
      name: 'สิงหาคม'
    },
    {
      number: 9,
      name: 'กันยายน'
    },
    {
      number: 10,
      name: 'ตุลาคม'
    },
    {
      number: 11,
      name: 'พฤศจิกายน'
    },
    {
      number: 12,
      name: 'ธันวาคม'
    }
  ];


  get_managerList() {
    const _getNewsPeriodUrl = cmsApi + '/get_managerList/'
    const _getNewsPeriodBody = {
      IsActive: '1',
      search: ''
    }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  get_transactionList() {
    const _getNewsPeriodUrl = cmsApi + '/get_transactionList/'
    const _getNewsPeriodBody = {
      IsActive: '1',
      search: ''
    }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  get_guidelineList() {
    const _getNewsPeriodUrl = cmsApi + '/get_guidelineList/'
    const _getNewsPeriodBody = {
      IsActive: '1',
      search: ''
    }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  get_voteList() {
    const _getNewsPeriodUrl = cmsApi + '/get_voteList/'
    const _getNewsPeriodBody = {
      IsActive: '1',
      search: ''
    }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  get_holdingInvestUnitList() {
    const _getNewsPeriodUrl = cmsApi + '/get_holdingInvestUnitList/'
    const _getNewsPeriodBody = {
      IsActive: '1',
      search: ''
    }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  get_assignedPersonnelList() {
    const _getNewsPeriodUrl = cmsApi + '/get_assignedPersonnelList/'
    const _getNewsPeriodBody = {
      IsActive: '1',
      search: ''
    }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  get_managerListById(managerList_id) {
    const _getNewsPeriodUrl = cmsApi + '/get_managerListById/'
    const _getNewsPeriodBody = { managerList_id: managerList_id }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  get_transactionById(transaction_id) {
    const _getNewsPeriodUrl = cmsApi + '/get_transactionById/'
    const _getNewsPeriodBody = { transaction_id: transaction_id }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  get_guidelineById(guideline_id) {
    const _getNewsPeriodUrl = cmsApi + '/get_guidelineById/'
    const _getNewsPeriodBody = { guideline_id: guideline_id }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }


  get_voteById(vote_id) {
    const _getNewsPeriodUrl = cmsApi + '/get_voteById/'
    const _getNewsPeriodBody = { vote_id: vote_id }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  get_holdingInvestUnitById(holdingInvestUnit_id) {
    const _getNewsPeriodUrl = cmsApi + '/get_holdingInvestUnitById/'
    const _getNewsPeriodBody = { holdingInvestUnit_id: holdingInvestUnit_id }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  get_assignedPersonnelById(id) {
    const _getNewsPeriodUrl = cmsApi + '/get_AssignedPersonnelById/'
    const _getNewsPeriodBody = { id: id }
    return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody)
  }

  changeFormatDate_dd(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() + 543;
      const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
      return day;
    }
  }

  changeFormatDate_MM(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() + 543;
      const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
      return monthTh['name'];
    }
  }

  changeFormatDate_yy(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() + 543;
      const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
      return year;
    }
  }

  changeFormatDate(date) {
    if (date === '') {
      return null
    } else {
      const d = new Date(date);
      const month = d.getMonth() + 1;
      const day = d.getDate()
      const year = d.getFullYear() + 543;
      const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
      return day + ' ' + monthTh['name'] + ' ' + year;
    }
  }

  date_thai(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day   = d.getDate();
    const year  = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
    return (day + ' ' + monthTh['name'] + ' ' + year);
  }

  date_thai_dd(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day   = d.getDate();
    const year  = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
    return (day);
  }

  date_thai_mm(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day   = d.getDate();
    const year  = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
    return (monthTh['name']);
  }

  date_thai_yy(date) {
    const d = new Date(date);
    const month = d.getMonth() + 1;
    const day   = d.getDate();
    const year  = d.getFullYear() + 543;
    const monthTh = this.checkMonth.filter(m => m['number'] === month)[0];
    return (year);
  }

}
